export interface ISelection {
    company: IOption;
    installation: IOption;
    filteredOptions: ISearchResult[];
    searchText: string;
}

export interface IApplication {
    id: number;
    name: string;
    logoUrl?: string;
    availability?: number;
}

export interface IRole {
    name: string;
    hierarchyDisplayName: string;
    path: string;
}

export interface IRoles {
    global: IRole[];
    companyGroup: IRole[];
    company: IRole[];
    installation: IRole[];
}

export interface IUser {
    id: number;
    name: string;
    email: string;
    roles: IRoles;
    isGlobalAdministrator: boolean;
    isCompanyAdministrator: boolean;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    workTitle: string;
    signatureFileName: string;
    signatureFileUrl: string;
}

export interface IRigInfo {
    id: number;
    displayName: string;
    staticName: string;
}

export interface IItemSearchResult {
    root_id: string;
    isGlobal: boolean;
    applicationId: string;
    name: string;
    tag: string;
    serialNumber: string;
    typeId: string;
    companyId: string;
    installationId: string;
    companyDisplayName: string;
    companyLegacyName: string;
    installationDisplayName: string;
    installationLegacyName: string;
    certificateId: string;
    certificateTitle: string;
}
export interface ICompany extends IRigInfo {
    installations: IInstallation[];
}

export interface IInstallation extends IRigInfo {}

export interface IHierarchyRole {
    hierarchyAssignmentDisplayPath: string;
    hierarchyAssignmentPath: string;
    name: string;
    userId: number;
}

export interface IUserRoles {
    global: IHierarchyRole[];
    companiesRoles: IHierarchyRole[];
    companyGroupsRoles: IHierarchyRole[];
    installationRoles: IHierarchyRole[];
}

export interface ICurrentUser {
    email: string;
    emailStatus: string;
    firstName: string;
    id: number;
    lastName: string;
    registrationStatus: string;
    isGlobalAdmin: boolean;
    isCompanyAdmin: boolean;
    userRoles: IUserRoles;
    phoneNumber: string;
    workTitle: string;
    signatureFileName: string;
    signatureFileUrl: string;
}

export interface ICurrentCompaniesAndInstallations {
    displayName: string;
    id: number;
    published: boolean;
    staticId: string;
    company: {
        displayName: string;
        id: number;
        published: boolean;
        staticId: string;
    };
}

export enum OptionType {
    NONE = 'NONE',
    COMPANY = 'COMPANY',
    INSTALLATION = 'INSTALLATION',
    MODULE = 'MODULE',
}

export interface IOption {
    id: number;
    key: string;
    value: string;
    rootName?: string;
    rootId?: number;
    type: OptionType;
}
export interface ISearchResult extends IOption {
    startIndex: number;
    endIndex: number;
    splitIndex: number;
    sortIndex: number;
    searchValue: string;
}

export interface ISearchResultText {
    beforeText: string;
    searchedText: string;
    afterText: string;
    subElementText: string;
}

export interface INotification {
    notificationId: number;
    title: string;
    wasNotified: boolean;
    activationDate: string;
    startDate: string;
    endDate: string;
    shortDescription: string;
    longDescription: string;
    isArchived: boolean;
    isGlobal: boolean;
    importanceLevel: string;
    scopeCompanies: number[];
    scopeInstallations: number[];
}

export interface IDocumentPreview {
    id: string;
    title: string;
    contentType: string;
    url: string;
}

export interface IItemOverview {
    itemId: string;
    serialNumber: string;
    tagNumber: string;
    itemName: string;
    itemType: string;
    assemblyFolder: string;
    area: string;
    imageUrl: string;

    manufacturer: string;
    supplier: string;
    model: string;
    locationDescription: string;
    locationRoom: string;
    locationPosition: string;
    locationDeck: string;
    access: string;
    otherId: string;
    dateStartUse: string;
    scanningUid: string;
    createdDate: string;
    createdBy: string;
    criticality: number | null;
    inspectionFrequency: number | null;

    dynamicAttributes: IDynamicAttribute[];
    lastInspectionStatus: IInspectionStatus | null;
    testPoints: ITestPoint[];
    documents: IDocument[];
}

export interface IDynamicAttribute {
    id: string;
    label: string;
    value: string;
    order: number;
}

export interface ITestPoint {
    entityId: string;
    name: string;
    location: string;
    dynamicAttributes: IDynamicAttribute[];
}

export interface IDocument {
    id: string;
    title: string;
    type: string;
    date: string;
    url: string | null;
    externalUrl: string | null;
    attachmentId: string | null;
    isExpired?: boolean;
}

export interface IInspectionStatus {
    id: string;
    statusCode: number | null;
    statusLabel: string;
    immediateDanger: boolean | null;
    registrationDate: string;
    dueDate: string;
    resolvedDate: string;
}

export class ModuleOption implements IOption {
    public readonly id: number;
    public readonly key: string;
    public readonly value: string;
    public readonly type: OptionType;

    constructor(name: string, id: number) {
        this.id = id;
        this.key = name.toLowerCase();
        this.value = name;
        this.type = OptionType.MODULE;
    }
}
export const analyticsModule: IOption = {
    id: 9,
    rootName: 'Bi Analytics',
    key: 'analytics',
    value: 'Analytics',
    type: OptionType.MODULE,
};
